import Vue from 'vue';
import exciseEntryTransformer from './../../transformers//exciseEntry';

const success = ({ data }, resolve) => {
  const excise = exciseEntryTransformer.fetch(data);
  resolve(excise);
};

const failed = (error, reject) => reject(error);

export default (id, excise) => (
  new Promise((resolve, reject) => {
    Vue.$http.put(`/excise_entries/${id}`, exciseEntryTransformer.send(excise))
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/exciseEntry/update.js